import { format } from "date-fns";
import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import withAuthProvider from "../../../services/withAuthProvider";
import { SkeletonNIPL } from "../../Skeleton/Skeleton";
import MoreButton from "../../MoreButton/MoreButton";
import toast from "react-hot-toast";

const initialPaginate = {
  page: 1,
  total: 1,
};

const NiplActive = () => {
  /* const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginate, setPaginate] = useState({ ...initialPaginate }); */

  const {
    data: queryData,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ["niplActive"],
    async ({ pageParam = 1 }) => {
      const response = await withAuthProvider.getDataWithAuth(`api/nipl/active`, { page: pageParam, page_size: 5 });
      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Failed to fetch active NIPL");
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page < lastPage.last_page) {
          return lastPage.current_page + 1;
        }
        return undefined;
      },
      keepPreviousData: true,
      onError: (err) => {
        toast.error(err.message, {
          id: "error-message",
          duration: 3000,
        });
      },
    }
  );

  const data = useMemo(() => {
    return queryData?.pages?.flatMap((page) => page.data) || [];
  }, [queryData]);

  return (
    <div className="overflow-auto" style={{ maxHeight: "600px" }}>
      <div className="d-flex flex-column" style={{ gap: "10px" }}>
        {isLoading
          ? new Array(3).fill(1).map((el, idx) => (
              <div className="border rounded-custom p-3 font-sm" key={idx}>
                <SkeletonNIPL />
              </div>
            ))
          : data.map((nipl, idx) => (
              <div className="border rounded-custom p-3 font-sm" key={idx}>
                <div className="fw-bold mb-1">
                  {nipl?.unit_type?.name} - {nipl?.code} {nipl?.nipl}
                </div>

                {nipl?.buyer?.is_master_auction !== 1 || nipl.location ? (
                  <div className="text-secondary">
                    {nipl?.location?.name},{" "}
                    {nipl?.auction?.date_start && nipl?.auction?.time_start
                      ? format(new Date(`${nipl?.auction?.date_start}`), "dd MMM yyyy")
                      : "-"}{" "}
                    {nipl?.auction?.date_start && nipl?.auction?.time_start
                      ? nipl?.auction?.time_start?.substr(0, 5)
                      : "-"}
                  </div>
                ) : (
                  <>{nipl?.buyer?.is_master_auction === 1 && <span className="badge-pumper">Pumper</span>}</>
                )}
              </div>
            ))}
        {data.length === 0 && isLoading === false && (
          <div className="px-3 py-2 font-sm text-center text-secondary w-100">Tidak ada NIPL</div>
        )}
      </div>
      {hasNextPage && <MoreButton onClick={() => fetchNextPage()} loading={isFetchingNextPage} />}
    </div>
  );
};

export default NiplActive;
